
import { DynamicFilter, VALUELESS_OPERATORS } from "../../filters/DynamicFilter";

export default {
  data() {
    return {
      open: true,
      uiField: this.filter.getUiField(),
      updateValueDebounced: _.debounce(() => {
        this.filter.property.set(this.uiField.property.typedValue);
      }, 100),
      renderKey: 0,
    };
  },
  props: {
    filter: {
      type: DynamicFilter,
      required: true,
    },
  },
  methods: {
    selectOperator(operator) {
      this.filter.setOperator(operator);
      // setOperator clears the property when the value shape (single vs
      // set) changes -- rebuild the widget from the filter's field so a
      // switch to/from "is one of"/"is none of" renders single- vs
      // multi-select and starts from the (now-cleared) current value.
      this.uiField = this.filter.getUiField();
    },
  },
  mounted() {
    if (this.filter.value) {
      this.open = false;
    }

    this.filter.getValueAsync();
  },
  computed: {
    operatorChoices() {
      return this.filter.operators.map((operator) => ({
        text: operator.label,
        value: operator.key,
      }));
    },
    showValue() {
      return (
        this.filter.operator &&
        !VALUELESS_OPERATORS.includes(this.filter.operator)
      );
    },
  },
  watch: {
    open(val) {
      if (!val && typeof this.filter.value !== "undefined")
        setTimeout(() => (this.showOperatorSelect = true), 250);
    },
    "uiField.property.value": {
      handler() {
        this.updateValueDebounced();
      },
    },
  },
};
